import { createBaseApi } from '../baseApi';

const productPhotoApi = createBaseApi('productPhotoApi');

export const enhancedProductPhotoApi = productPhotoApi.injectEndpoints({
  endpoints: (builder) => ({
    // Start generating a product photo (returns jobId immediately)
    generateProductPhoto: builder.mutation({
      query: ({ imageUrl, imageId }) => ({
        url: '/product-photo/generate',
        method: 'POST',
        body: { imageUrl, imageId }
      }),
    }),

    // Start editing a product photo (returns jobId immediately)
    editProductPhoto: builder.mutation({
      query: ({ imageUrl, editPrompt }) => ({
        url: '/product-photo/edit',
        method: 'POST',
        body: { imageUrl, editPrompt }
      }),
    }),

    // Poll job status
    getProductPhotoStatus: builder.query({
      query: (jobId) => ({
        url: `/product-photo/status/${jobId}`,
      }),
    }),

    // Get the user's shared credit balance
    getPhotoCredits: builder.query({
      query: () => ({
        url: '/product-photo/credits',
      }),
      providesTags: ['Credits'],
    }),

    // List available credit packages
    getCreditPackages: builder.query({
      query: () => ({
        url: '/credit-packages',
      }),
    }),

    // Purchase a credit package (creates Stripe PaymentIntent)
    purchaseCreditPackage: builder.mutation({
      query: ({ packageId, savedPaymentMethodId }) => ({
        url: '/credit-packages/purchase',
        method: 'POST',
        // Forward the saved payment method so the backend attaches the card to
        // the PaymentIntent. Without this the confirm 400s with "no payment method".
        body: { packageId, ...(savedPaymentMethodId && { savedPaymentMethodId }) }
      }),
    }),

    // Confirm a credit package purchase after Stripe payment
    confirmCreditPurchase: builder.mutation({
      query: ({ paymentIntentId }) => ({
        url: '/credit-packages/confirm',
        method: 'POST',
        body: { paymentIntentId }
      }),
      invalidatesTags: ['Credits'],
    }),
  })
});

export const {
  useGenerateProductPhotoMutation,
  useEditProductPhotoMutation,
  useLazyGetProductPhotoStatusQuery,
  useGetPhotoCreditsQuery,
  useGetCreditPackagesQuery,
  usePurchaseCreditPackageMutation,
  useConfirmCreditPurchaseMutation,
} = enhancedProductPhotoApi;
